import { render, staticRenderFns } from "./FileBrowserSelectedSection.vue?vue&type=template&id=4049eafb"
import script from "./FileBrowserSelectedSection.vue?vue&type=script&lang=js"
export * from "./FileBrowserSelectedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports